// extracted by mini-css-extract-plugin
export default {"list":"ListContainer_list__5okvy","spin":"ListContainer_spin__VS2Pi"};